import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
export function StandardPopover(props) {
    const { isOpen, setIsOpen, anchorElement, children } = props;
    const actionRef = useRef(null);
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const handle = window.setInterval(() => {
            if (actionRef.current && isOpen) {
                actionRef.current.updatePosition();
            }
        }, 100);
        return () => clearInterval(handle);
    }, [isOpen]);
    return (_jsx(Popover, { action: actionRef, open: isOpen, onClose: () => setIsOpen(false), anchorEl: anchorElement, anchorOrigin: { vertical: "top", horizontal: "right" }, children: _jsx(Box, { sx: {
                m: 2,
            }, children: children }) }));
}
//# sourceMappingURL=StandardPopover.js.map